var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentMethodXrpcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1005 6H17.8109L14.2514 9.5243C12.9624 10.7999 10.8725 10.7999 9.58255 9.5243L6.02173 6H7.73349L10.4377 8.6772C10.8317 9.06553 11.3627 9.28322 11.9159 9.28322C12.4692 9.28322 13.0001 9.06553 13.3941 8.6772L16.1005 6Z",
    fill: "#23292F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71153 15.8001H6L9.58255 12.2541C10.8716 10.9785 12.9615 10.9785 14.2514 12.2541L17.834 15.8001H16.1236L13.3962 13.1012C13.0022 12.7129 12.4712 12.4952 11.918 12.4952C11.3648 12.4952 10.8338 12.7129 10.4398 13.1012L7.71153 15.8001Z",
    fill: "#23292F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodXrpcoin);
export default __webpack_public_path__ + "static/media/icon_payment_method_xrpcoin.a893572c52eadc30f77ca1cdb848c8f9.svg";
export { ForwardRef as ReactComponent };